import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for ReportsRoot component
 */
export const useReportsRootStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2),
    },
    loadingState: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(8),
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(8),
        color: theme.palette.text.secondary,
    },
    hoverGrey200: {
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        },
    },
}))
